// extracted by mini-css-extract-plugin
export default {"wrapper":"NavBar_wrapper__pBvbZ","logo":"NavBar_logo__rM6Pd","point":"NavBar_point__nuEtG"};